import type { ReactNode } from 'react'
import { Sidebar } from './Sidebar'

export function AppShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex h-[100dvh] w-full overflow-hidden bg-app-bg text-text-default font-sans">
      <Sidebar />
      {children}
    </div>
  )
}

// Page is the per-feature frame below the shell: OLD's h-14 header bar plus a
// scrollable, width-capped content column. Pages compose this and supply only
// content; they set no layout/padding classes themselves. `width` picks the
// content cap: narrow (data lake, theses) vs wide (trades, dense tables).
export function Page({
  header,
  tabs,
  width = 'wide',
  children,
}: {
  header?: ReactNode
  tabs?: ReactNode
  width?: 'narrow' | 'wide'
  children: ReactNode
}) {
  const cap = width === 'narrow' ? 'max-w-3xl' : 'max-w-7xl'
  return (
    <div className="flex flex-col flex-1 h-full bg-app-bg min-w-0">
      {header}
      {tabs}
      <div className="flex-1 overflow-y-auto px-4 sm:px-6 lg:px-12 py-6">
        <div className={`mx-auto flex flex-col gap-4 ${cap}`}>{children}</div>
      </div>
    </div>
  )
}
